import {useState,useEffect} from "react";
import { Link ,useLocation, useOutletContext } from "react-router-dom";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import GameSvcCtntCtxtApi from "Apis/GameSvcCtntCtxtApi";
import "Assets/css/Ctnt.css"
import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { sanitizeContent } from 'Utils/sanitizeConfig';
import NoDataUi from "Views/Comm/NoDataUi";
import MgpStore from "Stores/Store";
import FaqCtgrLstInqApi from "Apis/FaqCtgrLstInqApi";
import GamePageBanner from "Components/GamePageBanner";

import "Assets/css/Cs.css";
import { BorderTop } from "@mui/icons-material";

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&::before': {
      display: 'none',
    },
  }));
  
  const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
  ))(({ theme }) => ({
  //   backgroundColor: 'rgba(0, 0, 0, .03)',
  //   flexDirection: 'row-reverse',
  //   '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
  //     transform: 'rotate(90deg)',
  //   },
  //   '& .MuiAccordionSummary-content': {
  //     marginLeft: theme.spacing(1),
  //   },
  //   ...theme.applyStyles('dark', {
  //     backgroundColor: 'rgba(255, 255, 255, .05)',
  //   }),
  }));
  
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));

const FaqLstUi = ({gameSvcCd,ctntKindCd,ctntCtgrCdName}:any) => {
    const { gameMainPageData, langData }:any = useOutletContext();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [faqCtgrLstState,setFaqCtgrLstState] = useState([]);
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntLstState,setCtntLstState] = useState<any>([]);
    const [faqCtgrCdState,setFaqCtgrCdState] = useState("");
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
        
    let test1:any;
     const [expanded, setExpanded] = React.useState<string | false>('panel1');
     
    // 모바일 카테고리 메뉴 열림 시 body 스크롤 방지
    useEffect(() => {
        if (isMobileCategoryOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileCategoryOpen]);
    
    const handleChange =
    (panel: string,GameSvcCd:string,ctntSno:string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setCtntCtxtState("");
        setExpanded(newExpanded ? panel : false);
        GameSvcCtntCtxtApi(GameSvcCd,ctntSno)
        .then((Resp) => {
            const dirty = Resp.apiBody.ctntCtxt;
            test1 = sanitizeContent(dirty);
            setCtntCtxtState(test1);
        })
    };
    const handlePageChange = (pageState:any) => {
        setPageState(pageState);
        GameSvcCtntPstdLstInqApi(gameSvcCd,ctntKindCd,pageState,"",null).then((resp)=> {
            setCtntLstState(resp.apiBody.ctntLst);
            // setCtntKindCdState(resp.apiBody.ctntLst)
            setPageState(resp.apiBody.nowPageNo)
            setOnePageSizeState(resp.apiBody.onePageSize)
            setTotPstdCntState(resp.apiBody.totCnt)
        })
      };
    const location= useLocation();  
        const serchParamsFunc = () => {
            return new URLSearchParams(location.search);
        }
        let query =serchParamsFunc();
        let getGameSvcCd = query.get("gameSvcCd");
        let getctntKindCd = query.get("ctntKindCd");
        if(getGameSvcCd !=null){
            gameSvcCd = getGameSvcCd;
            ctntKindCd = getctntKindCd;
        }
    
        if(gameSvcCd ==null) {
            gameSvcCd = location.state?.gameSvcCd;
        }
        if(ctntKindCd ==null) {
            ctntKindCd = location.state?.ctntKindCd;
        }
    const [ctntKindCdState,setCtntKindCdState] = useState<any>();
    useEffect(()=>{
        FaqCtgrLstInqApi(gameSvcCd,"faq").then((resp)=> {
            setFaqCtgrLstState(resp.apiBody.ctgrLst);
            setFaqCtgrCdState(resp.apiBody.ctgrLst[0].ctgrCd);
            GameSvcCtntPstdLstInqApi(gameSvcCd,ctntKindCd,pageState,"",resp.apiBody.ctgrLst[0].ctgrCd).then((resp)=> {
                // setCtntKindCdState(resp.apiBody.ctntLst)
                setPageState(resp.apiBody.nowPageNo)
                setOnePageSizeState(resp.apiBody.onePageSize)
                setTotPstdCntState(resp.apiBody.totCnt)
                //setExpanded(`panel${resp.apiBody.ctntLst[0].ctntSno}`)
                setCtntLstState(resp.apiBody.ctntLst);
                GameSvcCtntCtxtApi(gameSvcCd,resp.apiBody.ctntLst[0].ctntSno)
                .then((Resp) => {
                    const dirty = Resp.apiBody.ctntCtxt;
                    // test1 = sanitizeHtml(dirty,{
                    //     allowedTags:sanitizeHtml.defaults.allowedTags.concat([ 'img','span' ]),
                    //     allowedAttributes:{

                    //         img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height' ],
                    //         a: [ 'href', 'name', 'target' ],
                    //     },
                    //     parseStyleAttributes: false,
                    // });
                    setCtntCtxtState(Resp.apiBody.ctntCtxt);
                })
            });
        })
      },[MgpStore.getState().LangSetState.Lang])
      const FaqCtgrChngFunc = (faqCtgrCd:string) => {
        setFaqCtgrCdState(faqCtgrCd);
        GameSvcCtntPstdLstInqApi(gameSvcCd,ctntKindCd,pageState,"",faqCtgrCd).then((resp)=> {
            setPageState(resp.apiBody.nowPageNo)
            setOnePageSizeState(resp.apiBody.onePageSize)
            setTotPstdCntState(resp.apiBody.totCnt)
            setCtntLstState(resp.apiBody.ctntLst);
            GameSvcCtntCtxtApi(gameSvcCd,resp.apiBody.ctntLst[0].ctntSno)
            .then((Resp) => {
                const dirty = Resp.apiBody.ctntCtxt;
                // test1 = sanitizeHtml(dirty,{
                //     allowedTags:sanitizeHtml.defaults.allowedTags.concat([ 'img','span' ]),
                //     allowedAttributes:{

                //         img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height' ],
                //         a: [ 'href', 'name', 'target' ],
                //     },
                //     parseStyleAttributes: false,
                // });
                setCtntCtxtState(Resp.apiBody.ctntCtxt);
            })
        });
      }
    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntKindCd);

    return(
        <div className="BgW">
            <GamePageBanner gameMainPageData={gameMainPageData} langData={langData} />
            <div className="container1580 mt30">
                 {/* 모바일 카테고리 버튼 */}
                <button 
                    className="mobileCategoryBtn"
                    onClick={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
                >
                    <span>
                        {(faqCtgrLstState as any[]).find((cat: any) => cat.ctgrCd === faqCtgrCdState)?.ctgrNm || '카테고리 선택'}
                    </span>
                    <span className={`category-arrow ${isMobileCategoryOpen ? 'up' : 'down'}`}></span>
                </button>
                <h1 className="ctntCtgrTitlTxt">
                    <a href="/cs/FaqLst?gameSvcCd=BBO&ctntKindCd=FAQ" className="ctntCtgrTitlTxtLink">
                        SUPPORT
                    </a>
                </h1>
                <div className="ctntLstWrap ctntPstdLstWrap faqLstContentsWrap">
                    <div className="faqLst">
                        
                        {/* 모바일 배경 오버레이 */}
                        {isMobileCategoryOpen && (
                            <div 
                                className="mobileMenuOverlay"
                                onClick={() => setIsMobileCategoryOpen(false)}
                            />
                        )}
                        
                        <div className={`faqCtgrLstWrap ${isMobileCategoryOpen ? 'mobileOpen' : ''}`}>
                            <ul>
                                {faqCtgrLstState&&faqCtgrLstState.map((key:any)=>(
                                    <li className={faqCtgrCdState&&faqCtgrCdState == key.ctgrCd ? "active":""} onClick={()=>{
                                        FaqCtgrChngFunc(key.ctgrCd);
                                        setIsMobileCategoryOpen(false);
                                    }}>
                                        <p>{key.ctgrNm}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div style={{width:"100%"}}>
                            <div className="faqMainTopWrap ctntCtgr">
                                <div className="faqMainTopLinkWrap">
                                    <h1 className="ctntCtgrTitl">FAQ</h1>
                                </div>
                                <div className="faqMainTopQnaWrap">
                                    <Link to={"/MyPage/QnaLst?gameSvcCd="+gameSvcCd+"&ctntKindCd=QNA"}>
                                        <img src={process.env.PUBLIC_URL + "/images/common/qnaIcon.png"} alt="" />
                                        <p>{langData&&langData.CS_QNA_LST_BTN_01}</p>
                                        
                                    </Link>
                                    <Link to={"/MyPage/QnaWrite?gameSvcCd="+gameSvcCd}>
                                        <img src={process.env.PUBLIC_URL + "/images/common/qnawIcon.png"} alt="" />
                                        <p>{langData&&langData.CS_QNA_REG_BTN_00}</p>
                                        
                                    </Link>
                                </div>
                            </div>
                            <div className="faqCtxtLstWrap">
                                {ctntLstState&&ctntLstState.length != 0 ?
                                    <>
                                    {ctntLstState&&ctntLstState.map((key:any) => (
                                        <>
                                        <Accordion  className={"faqAccordionMenu"} expanded={expanded === `panel${key.ctntSno}`} onChange={handleChange(`panel${key.ctntSno}`,gameSvcCd,key.ctntSno)}>
                                            <AccordionSummary className={"faqAccordionSummary"} aria-controls={`panel${key.ctntSno}d-content`} id={`panel${key.ctntSno}d-header`}>
                                                <Typography className={"faqAccordionTitl"}>
                                                    <div className="CtgrBadge">
                                                        <span>FAQ</span>
                                                    </div>
                                                    <h1>{key.ctntTitl}</h1>
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails  className={"faqAccordionDetails"}>
                                                <Typography>
                                                    
                                                        {ctntCtxtState != null?
                                                        <div className="trmsCtxt ctntCtxt faqCtxt" 
                                                        dangerouslySetInnerHTML={{
                                                            __html: ctntCtxtState,
                                                        }}>
                                                        </div>    
                                                    :
                                                    <></>
                                                    }
                                                    <p className="aplyStrtDtime">{langData&&langData.CS_QNA_REG_DTIME_LBL_00} : {key.aplyStrtDtime}</p>
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                        </>
                                    ))}
                                    </>:
                                    <div className="faqNoLst">
                                            <NoDataUi noDataDesc={langData&&langData.CS_NO_DATA_LBL_00}/>
                                            {/* 등록된 글이 존재하지 않습니다. */}
                                    </div>
                                }
                            </div>
                        </ div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default FaqLstUi;